// extracted by mini-css-extract-plugin
export default {"container":"InvoiceAddEditLoading_container__GQESD"};